import React from 'react'

const LinkTag: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<any>>> = ({
    children,
    loading,
    ...tagProps
}) => <a {...tagProps}>{children}</a>

export default LinkTag
